// import React from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// const TestimonialSectionKeyword = ({
//   title = "What Our Customers Say",
//   subtitle = "Testimonial",
//   testimonials = [],
//   autoplay = true,
//   autoplaySpeed = 3000,
// }) => {
//   const renderStars = (count) => {
//     return Array.from({ length: count }).map((_, i) => (
//       <span key={i} style={{ color: "#C92227", marginRight: "2px" }}>
//         <i className="fa fa-star"></i>
//       </span>
//     ));
//   };

//   const sliderSettings = {
//     dots: true,
//     infinite: true,
//     speed: 600,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: autoplay,
//     autoplaySpeed: autoplaySpeed,
//     pauseOnHover: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: { slidesToShow: 1, slidesToScroll: 1 },
//       },
//       {
//         breakpoint: 768,
//         settings: { slidesToShow: 1, slidesToScroll: 1 },
//       },
//     ],
//     appendDots: (dots) => (
//       <div
//         style={{
//           marginTop: "20px",
//         }}
//       >
//         <ul style={{ margin: "0px", padding: "0px" }}>{dots}</ul>
//       </div>
//     ),
//     customPaging: () => (
//       <div
//         style={{
//           width: "12px",
//           height: "12px",
//           borderRadius: "50%",
//           background: "#ccc",
//         }}
//       />
//     ),
//   };

//   return (
//     <div
//       className="section-full "
//       style={{
//         background: "#f9f9f9",
//         overflowX: "hidden", // ✅ Prevent horizontal scroll
//       }}
//     >
//       <div className="container">
//         <div className="row justify-content-center text-center p-0">
//           <div className="col-lg-8">
//             <div className="section-head">
//               <div
//                 className="twm-sm-title"
//                 style={{ color: "#C92227", fontWeight: "600" }}
//               >
//                 {subtitle}
//               </div>
//               <h2
//                 className="twm-large-"
//                 style={{ color: "#002147", fontWeight: "700" }}
//               >
//                 {title}
//               </h2>
//             </div>
//           </div>
//         </div>

//         <div className="section-content">
//           <Slider {...sliderSettings}>
//             {testimonials.map((testimonial) => (
//               <div className="item" key={testimonial.id}>
//                 <div
//                   className="twm-testimonial2"
//                   style={{
//                     background: "#fff",
//                     borderRadius: "12px",
//                     padding: "30px",
//                     boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
//                     textAlign: "center",
//                     position: "relative",
//                     maxWidth: "100%",
//                     margin: "0 auto",
//                     boxSizing: "border-box",
//                   }}
//                 >
//                   {/* Quote icon */}
//                   <div
//                     className="twm-quote-icon"
//                     style={{
//                       position: "absolute",
//                       top: "-20px",
//                       right: "10px",
//                       fontSize: "30px",
//                       color: "#C92227",
//                     }}
//                   >
//                     <i className="fa fa-quote-right"></i>
//                   </div>

//                   {/* Name & role */}
//                   <div className="twm-author-detail mb-3">
//                     <h3
//                       className="twm-title"
//                       style={{ color: "#002147", marginBottom: "5px" }}
//                     >
//                       {testimonial.name}
//                     </h3>
//                     <div
//                       className="twm-position"
//                       style={{ color: "#555", fontSize: "14px" }}
//                     >
//                       {testimonial.position}
//                     </div>
//                   </div>

//                   {/* Feedback */}
//                   <div className="twm-testimonial-detail mb-3">
//                     <p style={{ color: "#333", fontSize: "16px" }}>
//                       {testimonial.feedback}
//                     </p>
//                   </div>

//                   {/* Rating */}
//                   <div className="twm-rating-wrap">
//                     {renderStars(testimonial.rating)}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </Slider>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TestimonialSectionKeyword;

import React, { useEffect, useState } from "react";
import "./TestimonialSectionKeyword.css";

const TestimonialSectionKeyword = ({
  title = "What Our Customers Say",
  subtitle = "CUSTOMER REVIEWS",
  testimonials = [],
  autoplay = true,
  autoplaySpeed = 3500,
}) => {
  const [current, setCurrent] = useState(0);

  const total = testimonials.length;

  const getInitial = (name = "") => {
    const cleanName = name
      .replace(/^(mr\.?|mrs\.?|miss\.?|ms\.?|dr\.?)\s+/i, "")
      .trim();

    return cleanName.charAt(0).toUpperCase();
  };

  const nextSlide = () => {
    if (total <= 1) return;

    setCurrent((prev) => (prev + 1) % total);
  };

  const prevSlide = () => {
    if (total <= 1) return;

    setCurrent((prev) => (prev - 1 + total) % total);
  };

  useEffect(() => {
    if (!autoplay || total <= 1) return;

    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % total);
    }, autoplaySpeed);

    return () => clearInterval(timer);
  }, [autoplay, autoplaySpeed, total]);

  if (!total) {
    return null;
  }

  const testimonial = testimonials[current];

  const rating = Math.round(testimonial.rating || 5);

  return (
    <section className="stt-keyword-testimonial">

      <div className="stt-keyword-container">

        {/* ================= HEADING ================= */}

        <div className="stt-keyword-heading">

          <div className="stt-keyword-label">
            <span></span>
            <strong>{subtitle}</strong>
            <span></span>
          </div>

          <h2>{title}</h2>

          <p>
            Real experiences from customers who travelled with
            Shreesha Tours & Travels.
          </p>

        </div>


        {/* ================= CAROUSEL ================= */}

        <div className="stt-carousel">

          {/* LEFT ARROW */}

          {total > 1 && (
            <button
              type="button"
              className="stt- stt-arrow-left"
              onClick={prevSlide}
              aria-label="Previous testimonial"
            >
              ‹
            </button>
          )}


          {/* CARD */}

          <div className="stt-carousel-window">

            <div className="stt-testimonial-card">

              {/* TOP RED LINE */}

              <div className="stt-card-top-line"></div>


              {/* CUSTOMER */}

              <div className="stt-customer">

                <div className="stt-avatar">
                  {getInitial(testimonial.name)}
                </div>

                <div className="stt-customer-details">

                  <h3>
                    {testimonial.name}
                  </h3>

                  <span>
                    {testimonial.position || "Happy Customer"}
                  </span>

                  <div className="stt-stars">

                    {[1, 2, 3, 4, 5].map((star) => (
                      <span
                        key={star}
                        className={
                          star <= rating
                            ? "stt-star active"
                            : "stt-star"
                        }
                      >
                        ★
                      </span>
                    ))}

                  </div>

                </div>

              </div>


              {/* REVIEW */}

              <div className="stt-review-box">

                <div className="stt-quote">
                  “
                </div>

                <p>
                  {testimonial.feedback}
                </p>

              </div>


              {/* BOTTOM */}

              <div className="stt-testimonial-footer">

                {/* <div className="stt-verified">

                  <span className="stt-check">
                    ✓
                  </span>

                  <span>
                    Verified Customer
                  </span>

                </div> */}

                <div className="stt-counter">
                  {String(current + 1).padStart(2, "0")}
                  <span>/</span>
                  {String(total).padStart(2, "0")}
                </div>

              </div>

            </div>

          </div>


          {/* RIGHT ARROW */}

          {total > 1 && (
            <button
              type="button"
              className="stt-carousel-arrow stt-arrow-right"
              onClick={nextSlide}
              aria-label="Next testimonial"
            >
              ›
            </button>
          )}

        </div>


        {/* ================= DOTS ================= */}

        {total > 1 && (
          <div className="stt-dots">

            {testimonials.map((_, index) => (
              <button
                type="button"
                key={index}
                className={
                  current === index
                    ? "stt-dot active"
                    : "stt-dot"
                }
                onClick={() => setCurrent(index)}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}

          </div>
        )}

      </div>

    </section>
  );
};

export default TestimonialSectionKeyword;
